import { apiRequest } from './client'
import type { RoadmapEntry, RoadmapStatus } from './types'

export const roadmapApi = {
  list: (projectId: string) => apiRequest<{ data: RoadmapEntry[] }>('/roadmap', { query: { projectId } }),

  get: (id: string) => apiRequest<{ data: RoadmapEntry }>(`/roadmap/${id}`),

  create: (input: {
    projectId: string
    title: string
    description?: string
    phaseLabel: string
    goal?: string
    status?: RoadmapStatus
    startDate?: string
    targetDate?: string
  }) => apiRequest<{ data: RoadmapEntry }>('/roadmap', { method: 'POST', body: input }),

  update: (
    id: string,
    input: Partial<{
      title: string
      description: string
      phaseLabel: string
      goal: string
      status: RoadmapStatus
      startDate: string | null
      targetDate: string | null
      progress: number
    }>,
  ) => apiRequest<{ data: RoadmapEntry }>(`/roadmap/${id}`, { method: 'PATCH', body: input }),

  remove: (id: string) => apiRequest<{ data: { success: boolean } }>(`/roadmap/${id}`, { method: 'DELETE' }),

  setTasks: (id: string, taskIds: string[]) => apiRequest<{ data: RoadmapEntry }>(`/roadmap/${id}/tasks`, { method: 'PATCH', body: { taskIds } }),

  setAssignees: (id: string, userIds: string[], roleIds: string[]) =>
    apiRequest<{ data: RoadmapEntry }>(`/roadmap/${id}/assignees`, { method: 'PATCH', body: { userIds, roleIds } }),

  reorder: (projectId: string, orderedIds: string[]) =>
    apiRequest<{ data: RoadmapEntry[] }>('/roadmap/reorder', { method: 'POST', body: { projectId, orderedIds } }),
}
